import classNames from 'classnames';
import { SurveyActionBar, SurveyQuestionFile } from 'survey-react-ui';
import { IonNote, IonSpinner } from '@ionic/react';

import SurveyFileImage from './SurveyFile.svg?react';

import file from './SurveyFile.module.scss';

export class SurveyFile extends SurveyQuestionFile {
  protected renderLoadingIndicator(): JSX.Element {
    return (
      <div className={file.loading}>
        <IonSpinner name="crescent" color="primary" />
      </div>
    );
  }

  protected renderElement(): JSX.Element {
    const preview = this.question.allowShowPreview
      ? this.renderPreview()
      : null;

    const loadingIndicator = this.question.showLoadingIndicator
      ? this.renderLoadingIndicator()
      : null;

    const video = this.question.isPlayingVideo ? this.renderVideo() : null;

    const fileDecorator = this.question.showFileDecorator
      ? this.renderFileDecorator()
      : null;

    const clearButton = this.question.showRemoveButton
      ? this.renderClearButton(this.question.cssClasses.removeButton)
      : null;

    const clearButtonBottom = this.question.showRemoveButtonBottom
      ? this.renderClearButton(this.question.cssClasses.removeButtonBottom)
      : null;

    const fileNavigator = this.question.fileNavigatorVisible ? (
      <SurveyActionBar model={this.question.fileNavigator}></SurveyActionBar>
    ) : null;

    let fileInput;
    if (this.question.isReadOnlyAttr) {
      fileInput = (
        <input
          readOnly
          type="file"
          className={
            !this.isDisplayMode
              ? this.question.cssClasses.fileInput
              : this.question.getReadOnlyFileCss()
          }
          id={this.question.inputId}
          ref={(input) => this.setControl(input)}
          style={!this.isDisplayMode ? {} : { color: 'transparent' }}
          multiple={this.question.allowMultiple}
          placeholder={this.question.title}
          accept={this.question.acceptedTypes}
        />
      );
    } else if (this.question.isDisabledAttr) {
      fileInput = (
        <input
          disabled
          type="file"
          className={
            !this.isDisplayMode
              ? this.question.cssClasses.fileInput
              : this.question.getReadOnlyFileCss()
          }
          id={this.question.inputId}
          ref={(input) => this.setControl(input)}
          style={!this.isDisplayMode ? {} : { color: 'transparent' }}
          multiple={this.question.allowMultiple}
          placeholder={this.question.title}
          accept={this.question.acceptedTypes}
        />
      );
    } else if (this.question.hasFileUI) {
      fileInput = (
        <input
          type="file"
          disabled={this.isDisplayMode}
          tabIndex={-1}
          className={
            !this.isDisplayMode
              ? this.question.cssClasses.fileInput
              : this.question.getReadOnlyFileCss()
          }
          id={this.question.inputId}
          ref={(input) => this.setControl(input)}
          style={!this.isDisplayMode ? {} : { color: 'transparent' }}
          aria-required={this.question.ariaRequired}
          aria-label={this.question.ariaLabel}
          aria-invalid={this.question.ariaInvalid}
          aria-errormessage={this.question.ariaErrormessage}
          multiple={this.question.allowMultiple}
          title={this.question.inputTitle}
          accept={this.question.acceptedTypes}
          // @ts-ignore
          capture={this.question.renderCapture}
        />
      );
    } else {
      fileInput = null;
    }

    return (
      <div className={file.question}>
        {!!this.question.title && <div>{this.question.title}</div>}
        <div
          className={classNames(this.question.fileRootCss, file.root, file.css)}
          ref={(el) => this.setContent(el)}
        >
          {fileInput}
          <div
            className={classNames(
              this.question.cssClasses.dragArea,
              file.dragarea,
              {
                [file.error]: this.question.errors.length,
              }
            )}
            onDrop={this.question.onDrop}
            onDragOver={this.question.onDragOver}
            onDragLeave={this.question.onDragLeave}
            onDragEnter={this.question.onDragEnter}
          >
            {fileDecorator}
            {loadingIndicator}
            {video}
            {clearButton}
            {preview}
            {clearButtonBottom}
            {fileNavigator}
          </div>
        </div>
      </div>
    );
  }

  protected renderFileDecorator(): JSX.Element {
    const image = this.question.isEmpty() ? (
      <SurveyFileImage width={122} height={90} />
    ) : null;

    const chooseButton = this.question.showChooseButton
      ? this.renderChooseButton()
      : null;

    const actionsContainer = this.question.actionsContainerVisible ? (
      <SurveyActionBar model={this.question.actionsContainer}></SurveyActionBar>
    ) : null;

    const noFileChosen = this.question.isEmpty() ? (
      <span className={this.question.cssClasses.noFileChosen}>
        {this.question.noFileChosenCaption}
      </span>
    ) : null;

    const error = this.question.errors.length ? (
      <IonNote color="danger" className={file.error}>
        {this.question.errors.map((item) => item.getText())[0]}
      </IonNote>
    ) : null;

    return (
      <div
        className={classNames(
          this.question.getFileDecoratorCss(),
          file.decorator
        )}
      >
        {image}
        {this.question.isEmpty() && (
          <span
            className={classNames(
              this.question.cssClasses.dragAreaPlaceholder,
              file.placeholder
            )}
          >
            {this.renderLocString(this.question.locRenderedPlaceholder)}
          </span>
        )}
        <div className={this.question.cssClasses.wrapper}>
          {chooseButton}
          {actionsContainer}
          {noFileChosen}
        </div>
        {error}
      </div>
    );
  }
}
